// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import Tasks, {type Task} from '@app/features/tasks/state/Tasks';

export function handleTaskUpsert(data: Task, _context: GatewayHandlerContext): void {
	Tasks.upsert(data);
}

export function handleTaskDelete(data: {id: string; guild_id: string}, _context: GatewayHandlerContext): void {
	Tasks.remove(data.guild_id, data.id);
}
